// extracted by mini-css-extract-plugin
module.exports = {"SectionPhone":"SectionPhone_SectionPhone__FhYjG"};